import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {TopPanelButtons} from './top-panel-buttons'

const TwTopPanelContainer = tw.div`
  pt-20
  pb-20
  mx-auto
  px-24 absolute z-1000 right-0
`

const TwTopPanelContent = tw.div`
  flex
  items-center
  h-24
  gap-8
  leading-6
  text-14
  font-semibold w-max
`

export const TopPanel = observer(() => {
  return (
    <div style={{width: 'calc(100% - 10px)'}}>
      <TwTopPanelContainer>
        <TwTopPanelContent>
          <TopPanelButtons />
        </TwTopPanelContent>
      </TwTopPanelContainer>
    </div>
  )
})
